import { Link } from "react-router-dom";
import { siteInfo, footerLinks } from "@/mocks/home";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-heart-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-xl text-background-50">{siteInfo.logo}</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              温暖有爱的社区交流平台，汇聚数百万用户，分享生活的每一个精彩瞬间。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="QQ">
                <i className="ri-qq-line text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">帮助中心</h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.help.map((link) => (
                <li key={link.label}>
                  {link.href.startsWith("/#") ? (
                    <a href={link.href} className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200">
                      {link.label}
                    </a>
                  ) : (
                    <Link to={link.href} className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200">
                      {link.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; 2026 {siteInfo.name}. All rights reserved. 爱情岛论坛网站版权所有
          </p>
          <p className="text-xs text-background-600">
            本站为非官方社区导航站点，致力于为用户提供便捷的访问指引
          </p>
        </div>
      </div>
    </footer>
  );
}